import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIdToScroll } from "../../reduxToolkit/features/miscFront";
import ContactUsForm from "../forms/ContactUsForm";
import Testimonials from "../testimonial/Testimonials";
import { colors, eyebrowSx, fonts, radii, shadows } from "../../theme/designTokens";

export default function TestimonialsNContactUs() {
  const testimonialRef = useRef();
  const contactRef = useRef();
  const dispatch = useDispatch();

  // Scroll functionality
  const { idToScroll } = useSelector((state) => state.miscFront);

  useEffect(() => {
    if (idToScroll === "testimonial") {
      setTimeout(() => {
        testimonialRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        dispatch(setIdToScroll(""));
      }, 250);
    }
    if (idToScroll === "contact-us") {
      setTimeout(() => {
        contactRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        dispatch(setIdToScroll(""));
      }, 250);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToScroll]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  const cardSx = {
    borderRadius: radii.lg,
    boxShadow: shadows.card,
    border: `1px solid ${colors.line}`,
    bgcolor: colors.white,
    p: { xs: 2.5, sm: 3.5 },
  };

  return (
    <Box sx={{ bgcolor: colors.paperTintWarm, py: { xs: 4, md: 6 } }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={6} sx={{ position: "relative" }}>
            <Box
              ref={testimonialRef}
              sx={{ position: "absolute", top: -200, height: 300 }}
            />
            <Box sx={cardSx}>
              <Box sx={{ ...eyebrowSx, mb: 2 }}>Customer Stories</Box>
              <Typography
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 800,
                  fontSize: { xs: "1.3rem", sm: "1.5rem" },
                  color: colors.ink,
                  mb: 2,
                }}
              >
                {translateFront("Word From Our Valued Customers")}
              </Typography>
              <Testimonials limit={2} columns={1} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sx={{ position: "relative" }}>
            <Box
              ref={contactRef}
              sx={{ position: "absolute", top: -100, height: 300 }}
            />
            <Box sx={cardSx}>
              <Box sx={{ ...eyebrowSx, mb: 2 }}>Get in Touch</Box>
              <Typography
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 800,
                  fontSize: { xs: "1.3rem", sm: "1.5rem" },
                  color: colors.ink,
                  mb: 1,
                }}
              >
                {translateFront("For Any Inquiry")}
              </Typography>
              <ContactUsForm />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
